import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tabulator-range",
  "use": "icon-tabulator-range-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol viewBox=\"0 0 16 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tabulator-range\">\n<path d=\"M1.33398 1H14.6673M1.33398 6H14.6673M1.33398 11H7.16732\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol